import React from 'react';
import { RangeKeyDict } from 'react-date-range';
import { IDateRangeCalendar } from './types';
import moment from 'moment';
import { useTheme } from '@material-ui/core/styles';
import { RangeCalendar } from 'src/components/Calendars';

/**
 * Represents a date range calendar
 *
 * @param {{
 *     onChange: (value: TRangeValue) => void
 *     value: TRangeValue
 * }} {
 *     onChange,
 *     value,
 * }
 * @return {*}
 */
export const DateRangeCalendar = ({ onChange, value }: IDateRangeCalendar) => {
    const theme = useTheme();

    const ranges = value
        ? [
              {
                  startDate: moment(value.gte).toDate(),
                  endDate: moment(value.lt).toDate(),
                  key: 'selection',
                  color: theme.palette.primary.main,
              },
          ]
        : [{ key: 'selection', color: theme.palette.primary.main }];

    const handleChange = (ranges: RangeKeyDict) => {
        const { startDate, endDate } = ranges.selection;

        onChange({
            gte: moment(startDate).startOf('day').toDate(),
            lt: moment(endDate).endOf('day').toDate(),
        });
    };

    return <RangeCalendar ranges={ranges} onChange={handleChange} />;
};
